import script from "./RevenueStatisticsNew.vue?vue&type=script&setup=true&lang=js"
export * from "./RevenueStatisticsNew.vue?vue&type=script&setup=true&lang=js"

import "./RevenueStatisticsNew.vue?vue&type=style&index=0&id=0385aabe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0385aabe"]])

export default __exports__